/** @jsx jsx */ import { css, jsx } from '@emotion/core'
import * as React from 'react'
import StyledComponent, { GetStylesType } from './StyledComponent'
import { PlayPauseButton as PPBtn } from '../Styles/index'
import { AudioContext } from '../Context'

const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
  disabled,
  styles,
  timeout = 100,
}) => {
  const { isPaused, play, pause, time, duration } = React.useContext(
    AudioContext
  )

  const value = Math.round((time * 100) / duration)
  const [isReallyPaused, setIsReallyPaused] = React.useState(isPaused)

  const progressValue = React.useRef<SVGCircleElement>(null)

  React.useEffect(() => {
    if (progressValue.current) {
      const RADIUS = 35
      const progress = Number(value) / 100
      const CIRCUMFERENCE = 2 * Math.PI * RADIUS
      const dashoffset: number = Number(CIRCUMFERENCE * (1 - progress))
      progressValue.current.style.strokeDashoffset = dashoffset.toFixed()
    }
  }, [value])

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (isPaused) {
        setIsReallyPaused(true)
      } else {
        setIsReallyPaused(false)
      }
    }, timeout)
    return () => clearTimeout(timer)
  }, [isPaused, timeout])

  return (
    <StyledComponent styles={styles}>
      {({ getStyles }: { getStyles: GetStylesType }) => (
        <button
          onClick={isPaused ? play : pause}
          css={getStyles('playPauseButton', {})}
          disabled={disabled}
        >
          <svg
            viewBox=" 0 0 78 79"
            css={css`
              width: 100%;
              height: 100%;
            `}
          >
            <circle
              cx="39"
              cy="39"
              r="35"
              strokeWidth="3"
              css={getStyles('progressLine', {})}
            />
            <circle
              cx="39"
              cy="39"
              r="35"
              strokeWidth="3"
              css={getStyles('progressLineActive', {})}
              ref={progressValue}
            />
            <path
              fill="currentColor"
              d={isReallyPaused ? playPath : pausePath}
            />
          </svg>
        </button>
      )}
    </StyledComponent>
  )
}

export default PlayPauseButton

type PlayPauseButtonProps = {
  className?: string
  disabled?: boolean
  timeout?: number
  styles?: PPBtn.StylesObj
}

const playPath =
  'M53.238,41.222 L32.253,52.806 C31.250,53.360 29.986,52.680 29.986,51.586 L29.986,28.418 C29.986,27.324 31.250,26.644 32.253,27.198 L53.238,38.782 C54.228,39.329 54.228,40.675 53.238,41.222 Z'

const pausePath =
  'M45.000,51.000 L43.654,51.000 C42.549,51.000 41.654,50.105 41.654,49.000 L41.654,30.000 C41.654,28.895 42.549,28.000 43.654,28.000 L45.000,28.000 C46.105,28.000 47.000,28.895 47.000,30.000 L47.000,49.000 C47.000,50.105 46.105,51.000 45.000,51.000 ZM34.346,51.000 L33.000,51.000 C31.895,51.000 31.000,50.105 31.000,49.000 L31.000,30.000 C31.000,28.895 31.895,28.000 33.000,28.000 L34.346,28.000 C35.451,28.000 36.346,28.895 36.346,30.000 L36.346,49.000 C36.346,50.105 35.451,51.000 34.346,51.000 Z'
